import clsx from 'clsx';
import React from 'react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const AvatarList = _ref => {
  var _items$slice, _items$slice$reverse;

  let {
    items,
    className = ''
  } = _ref;
  return /*#__PURE__*/_jsx("ul", {
    className: clsx(styles.container, className || ''),
    children: items === null || items === void 0 ? void 0 : (_items$slice = items.slice(0, 5)) === null || _items$slice === void 0 ? void 0 : (_items$slice$reverse = _items$slice.reverse()) === null || _items$slice$reverse === void 0 ? void 0 : _items$slice$reverse.map((avatar, index) => /*#__PURE__*/_jsx("li", {
      className: styles.item,
      children: /*#__PURE__*/_jsx("img", {
        loading: "lazy",
        className: styles.avatarImage,
        alt: `${avatar.alt}`,
        src: avatar.src
      })
    }, index))
  });
};

export default AvatarList;